// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"230":"component---src-pages-index-jsx","256":"component---src-pages-404-jsx","532":"styles"}[chunkId] + "-" + {"230":"74bf72925df9cdacccf6","256":"1af1851b91e0f86d75e2","532":"91b5f560e50bf5fc4466"}[chunkId] + ".js";
};